<template>
  <div class="courseList">
    <div class="mainBox">
      <div class="topTitle">课例观摩与解课</div>
      <!-- <div style="color:red;font-size: 16px;padding: 0px 0 30px;">
        该板块将于11月23日上线，敬请期待！
      </div> -->
      <div class="courseListBox">
        <a-carousel :before-change="onChange" :autoplay="true">
          <div v-for="(item, index) in totalPage" >
            <div class="courseWrap" v-if="!loading">
              <div class="oneCourse" v-for="cour in courseList" @click="goVideo(cour.courseViewId)">
                <img :src="cour.coverUrl?cour.coverUrl:require('../../../static/images/course_bg.png')" width="283" height="169" alt="">
                <!-- <img src="../../../static/images/course_bg.png" width="283" height="169" alt=""> -->
                <div class="courseInfo">
                  <p>{{cour.courseName}}</p>
                  <div class="realname">
                    <span>{{cour.authorName}}</span>
                    <span>{{cour.sectionName}}{{cour.subjectName}}</span>
                  </div>
                  <div class="toCourseBtn" >去解课</div>
                </div>
              </div>
            </div>
          </div>
        </a-carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      courseList: [],
      currentPage: 1,
      pageSize: 12,
      totalPage: 0,
      loading: false,
    }
  },
  created () {
    this.getCourseList();
  },
  props:['changeTab1'],
  methods: {
    goVideo(id){
      // goVideo
      // console.log(this.changeTab);
      this.$emit('changeTab1');
      this.$router.push('/videoDetail?videoid='+id);
      // window.open('/match/videoDetail?videoid='+id);
    },
    onChange(from,to) {
      this.loading = true;
      this.currentPage = to+1;
      this.getCourseList();
    },
    getCourseList(){
      this.axios.post(this.appUtils.getSignWithUrl(this.apis.home.getCourseList+'?currentPage='+this.currentPage+'&pageSize='+this.pageSize))
      .then((res)=>{
        this.loading = false;
        this.courseList = res.data.data;
        this.totalPage=res.data.pageInfo.totalPage;

      }).catch((err)=> {
        console.log(err);
      });
    }
  }
}
</script>

<style lang="less">
.courseList{
  padding-bottom: 50px;
  background: #F2F5F8;
  .topTitle{
    height: 36px;
    font-size: 26px;
    font-family: Microsoft YaHei;
    line-height: 36px;
    color: #333333;
    margin: 40px 0 25px;
  }
  .mainBox{
    width: 1200px;
    margin: 0 auto;
  }
  .courseListBox{
    .courseWrap{
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      .oneCourse{
        width: 283px;
        height: 289px;
        text-align: left;
        cursor: pointer;
        overflow: hidden;
        border-radius: 10px;
        margin: 0 22px 42px 0;
        &:nth-child(4n){
          margin-right: 0;
        }
        &:hover .courseInfo .toCourseBtn{
          background: #1890FF;
          color: #fff;
        }
        &:hover .courseInfo p{
          color: #1890FF;
        }
        &:hover .realname span{
          color: #1890FF;
        }
        .courseInfo{
          height: 120px;
          padding: 20px;
          position: relative;
          background: #fff;
          .toCourseBtn{
            width: 80px;
            height: 32px;
            line-height: 32px;
            background: #E6F7FF;
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: #8FC4F5;
            text-align: center;
          }
          &>p{
            font-size: 16px;
            font-family: Microsoft YaHei;
            line-height: 20px;
            color: #333333;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .realname{
            font-size: 14px;
            color: #999;
            margin-top: 5px;
            span{
              margin-right: 10px;
            }
          }
        }
      }
    }
    .ant-carousel .slick-dots-bottom{
      bottom: -34px;
    }
    .ant-carousel .slick-slide {
      text-align: center;
      // height: 160px;
      // line-height: 160px;
      overflow: hidden;
    }
    .ant-carousel .slick-dots li button {
      width: 7px;
      height: 7px;
      background: #2680EB;
      border-radius: 50%;
      opacity: 0.47;
    }
    .ant-carousel .slick-dots li.slick-active button{
      width: 10px;
      height: 10px;
      opacity: 1;
    }
    .ant-carousel .slick-dots{
      height: 10px;
      line-height: 10px;
    }
  }
}
</style>